import { THERAPIES } from "@/content";

export const Therapies = () => (
  <section className="therapies" id="terapias" data-testid="therapies-section">
    <div className="wrap">
      <div className="section-head">
        <p className="eyebrow">{THERAPIES.eyebrow}</p>
        <h2>{THERAPIES.title}</h2>
        <p>{THERAPIES.intro}</p>
      </div>
      <div className="therapy-grid">
        {THERAPIES.items.map((therapy) => (
          <article key={therapy.number}>
            <span>{therapy.number}</span>
            <h3>{therapy.title}</h3>
            <p>{therapy.text}</p>
            <a
              className="therapy-action"
              href={therapy.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`therapy-link-${therapy.number}`}
            >
              {THERAPIES.actionLabel}
            </a>
          </article>
        ))}
      </div>
      <a
        className="next-link"
        href={THERAPIES.nextLink.href}
        data-testid="therapies-next-link"
      >
        {THERAPIES.nextLink.label}
      </a>
      <p className="therapy-note">{THERAPIES.note}</p>
    </div>
  </section>
);
